<template>
  <div>
    <nav-header></nav-header>
    <div class="usermanage-form validate-form p-l-50 p-r-50 p-t-10 p-b-80">
      <section>
        <div style="text-align: center; margin-bottom: 20px; padding-top: 20px">
          <h2>Gestão de Empresas</h2>
        </div>
        <hr/>
        <b-container id="buscaCompany" fluid>
          <b-row style="margin-bottom: 10px;">
            <b-col lg="6" class="my-1">
              <b-form-group
                label="Filtro"
                label-for="filter-input"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="text"
                    v-on:input="searchCompanies"
                    placeholder="Digite para buscar"
                    autocomplete="off"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button style="marginTop: 0px" :disabled="!filter" @click="filter = '';getCompanies()"
                      >Limpar</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="6" class="my-1">
              <b-form-group
                v-model="sortDirection"
                label="Filtros Ligados"
                description="Deixe tudo desmarcado para filtrar todos os dados"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
                v-slot="{ ariaDescribedby }"
              >
                <b-form-checkbox-group
                  v-model="filterOn"
                  :aria-describedby="ariaDescribedby"
                  class="mt-1"
                >
                  <b-form-checkbox value="nome_empresa">Nome</b-form-checkbox>
                  <b-form-checkbox value="cnpj_empresa">CNPJ</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-table
            :ref="tableId"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            stacked="md"
            show-empty
            small
            @filtered="onFiltered"
            busy.sync="isBusy"
            class="mt-3"
            style="text-align: center;"
          >
            <template #cell(habilitada)="row">
              <b-badge class="badge-status" v-if="row.item.habilitada == 'S'" variant="success">Ativa</b-badge>
              <b-badge class="badge-status" v-else-if="row.item.habilitada" variant="danger">Desativa</b-badge>
            </template>
            <template v-if="!isBusy" #cell(actions)="row">
              <b-button-group>
                <b-button
                  size="sm"
                  @click="info(row.item, $event.target)"
                  class="mr-1 my-1 btn btn-primary"
                  v-b-tooltip.hover title="detalhar"
                >
                  <b-icon-search font-scale=".8" style="vertical-align: text-top;"/>
                </b-button>
                <b-button
                  variant="dark"
                  size="sm"
                  @click="$router.push({name: 'editCompany', params: {companyId: row.item['id_empresa']}})"
                  class="mr-1 my-1 btn btn-primary"
                  v-b-tooltip.hover title="alterar"
                >
                  <b-icon-pencil-fill font-scale=".8" style="vertical-align: text-top;" />
                </b-button>
                <b-button
                  v-if="row.item['habilitada'] == 'S'"
                  size="sm"
                  @click="enable(row.item, $event.target)"
                  class="my-1 btn btn-primary"
                  v-b-tooltip.hover title="desativar"
                >
                  <b-icon-x />
                </b-button>
                <b-button
                  v-if="row.item['habilitada'] == 'N'"
                  size="sm"
                  @click="enable(row.item, $event.target)"
                  class="my-1 btn btn-primary"
                  v-b-tooltip.hover title="ativar"
                >
                  <b-icon-check />
                </b-button>
              </b-button-group>
            </template>

            <template #cell(cnpj_empresa)="data">
              {{parseCnpj(data.value)}}
            </template>

            <template #cell(custo_requisicao)="data">
              {{ data.value!=='' ? 'R'+formatMoney(data.value || '$0') : ''}}
            </template>
          </b-table>
          <b-spinner v-if="isBusy" variant="danger" type="grow" label="Spinning"></b-spinner>

          <!-- Info modal -->
          <b-modal
            :id="infoModal.id"
            :title="infoModal.title"
            ok-only
            @hide="resetInfoModal"
          >
            <p><strong>Nome:</strong> {{ infoModal.content["nome_empresa"] }}</p>
            <p><strong>CNPJ:</strong> {{ parseCnpj(infoModal.content["cnpj_empresa"]) }}</p>
            <p><strong>Custo por Documento:</strong> R{{ formatMoney(infoModal.content["custo_requisicao"]) }}</p>
            <p><strong>Custo assinatura digital:</strong> R{{ formatMoney(infoModal.content["custo_assinatura"]) }}</p>
            <p><strong>Limite em megabytes mensal:</strong> {{ infoModal.content["limite_tamanho"] }} MB</p>
            <p><strong>Limite utilizado:</strong> {{ infoModal.content["limite_utilizado"] }} MB</p>
            <p><strong>Status:</strong> {{ infoModal.content["habilitada"] == "S" ? "Ativa" : "Desativa" }}</p>
          </b-modal>

          <b-modal
            :ref="enablementModal.id"
            :id="enablementModal.id"
            :title="enablementModal.title"
            @hide="resetEnablementModal"
            hide-footer
          >
            <p>Deseja <strong>{{enablementModal.content["habilitada"] == "S" ? "desativar" : "ativar"}}</strong> a empresa {{enablementModal.content["nome_empresa"]}} ?</p>
            <b-button @click="$refs[enablementModal.id].hide()">Cancelar</b-button>
            <b-button class="btn btn-primary m-r-10" @click="enableCompany">{{enablementModal.content["habilitada"] == "S" ? "Desativar" : "Ativar"}}</b-button>
          </b-modal>
        </b-container>
        <div>
          <b-input-group style="justify-content: right">
            <template #prepend>
              <b-input-group-text style="height: 70%; background: transparent">
                Por Página
              </b-input-group-text>
            </template>
            <div>
              <b-form-select
                id="per-page-select"
                class="no-shadow"
                v-model="perPage"
                :options="pageOptions"
              />
            </div>
            <template #append>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="right"
                first-number
                last-number
              />
            </template>
          </b-input-group>
        </div>
      </section>
    </div>
    <user-profile-footer></user-profile-footer>
  </div>
</template>

<style scoped src="@/assets/css/util.css">
</style>

<style scoped>
  .b-table[aria-busy="true"] + .table-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10; /* make sure spinner is over table */
  }
  .badge-status {
    border-radius: 0;
  }
  .spinner-grow {
    position: relative;
    top: 50%;
    left: 50%;
  }
  .no-shadow {
    border-radius: 0;
  }
  .no-shadow:focus, :active {
    border-color: lightgray;
    box-shadow: none !important;
  }
</style>

<script>
import axios from "axios";
import NavHeader from "../components/NavHeader.vue";
import UserProfileFooter from "../components/UserProfileFooter.vue";
import config from "../helpers/generalConfig";
import { BPagination, BTable, BSpinner } from "bootstrap-vue";

export default {
  components: {
    UserProfileFooter,
    NavHeader,
    BPagination,
    BTable,
    BSpinner
  },
  data() {
    return {
      isBusy: true,
      items: [{
        id_empresa: "",
        nome_empresa: "",
        cnpj_empresa: "",
        custo_requisicao: "",
        custo_assinatura: "",
        limite_tamanho: "",
        limite_utilizado: "",
        habilitada: ""
      }],
      fields: [
        { key: "nome_empresa", label: "Nome", sortable: true },
        { key: "cnpj_empresa", label: "CNPJ", sortable: true },
        { key: "custo_requisicao", label: "Custo por Documento", sortable: true },
        { key: "habilitada", label: "Status", sortable: true },
        { key: "actions", label: "Ações" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, { value: 100, text: "Mostrar todos" }],
      sortBy: "nome_empresa",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      enablementModal: {
        id: "enablement-modal",
        title: "",
        content: "",
      },
      tableId: "table"
    };
  },
  created() {
    this.getCompanies();
  },
  computed: {
    rows() {
      return this.items.length;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  watch: {
    filterOn: function () {
      this.searchCompanies();
    }
  },
  methods: {
    getCompanies() {
      const token = this.$store.getters["auth/token"].token;
      axios
        .get(`${config.jsonServer}/company/search/?nome_empresa=`, {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          this.isBusy = false;
          this.items = res.data;
          this.totalRows = this.items.length;
        })
        .catch((err) => {
          this.$bvToast.toast(err.response ? err.response.data.message : "Sem resposta", {
            title: "Erro na busca de empresas",
            variant: "danger",
            solid: true,
          });
        });
    },
    info(item, button) {
      this.infoModal.title = "Informações Detalhadas";
      this.infoModal.content = item;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    enable(item, button) {
      this.enablementModal.title = `${item["habilitada"] == "S" ? "Desativar" : "Ativar"} Empresa`;
      this.enablementModal.content = item;
      this.$root.$emit("bv::show::modal", this.enablementModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    resetEnablementModal() {
      this.enablementModal.title = "";
      this.enablementModal.content = "";
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    parseCnpj(cnpjString) {
      return (cnpjString||"").replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1.$2.$3/$4-$5");
    },
    unparseCnpj(cnpjString) {
      return (cnpjString||"").replace(/\D/g, '');
    },
    searchCompanies() {
      if(this.filter){
        let query = '';
        if(this.filterOn.length < 1){
          query = `nome_empresa=${this.filter}`;
          if(this.unparseCnpj(this.filter)){
            query += `&cnpj_empresa=${this.unparseCnpj(this.filter)}`;
          }
        }else{
          query = this.filterOn.map(
            f => `${f}=${f == 'cnpj_empresa' ? this.unparseCnpj(this.filter)||-1 : this.filter}`
          ).join('&');
        }
        axios
          .get(`${config.jsonServer}/company/search?${query}`, {
            headers: {
              Authorization: "Bearer " + this.$store.getters['auth/token'].token,
            },
          }).then(res => {
            this.items = res.data;
            this.totalRows = this.items.length;
          }).catch((err) => {
            this.$bvToast.toast(err.response ? err.response.data.message : "Sem resposta", {
              title: "Erro na busca de empresas",
              variant: "danger",
              solid: true,
            });
          });
      }else{
        this.getCompanies();
      }
    },

    enableCompany() {
      const token = this.$store.getters["auth/token"].token;
      axios
        .put(`${config.jsonServer}/company/update`, {
          id_empresa: this.enablementModal.content['id_empresa'],
          habilitada: this.enablementModal.content['habilitada'] == 'S'? 'N' : 'S' 
        }, {
          headers: {
            Authorization: "Bearer " + token,
          },
        }).then(res => {
          this.$bvToast.toast(
            `Empresa ${this.enablementModal.content["nome_empresa"]} foi ${this.enablementModal.content["habilitada"] == "S"? "desativada" : "ativada"} com sucesso`, 
            {
              title: `${this.enablementModal.content["habilitada"] == "S"? "Desativação" : "Ativação"} realizada`,
              variant: 'success',
              solid: true
            }
          );
          const ref = this.items.filter(company => company.cnpj_empresa == this.enablementModal.content.cnpj_empresa);
          Object.assign(ref[0], res.data);
          this.$refs['table'].refresh();
          this.$refs[this.enablementModal.id].hide();
        })
        .catch(err => {
          this.$bvToast.toast(
            `Erro ao ${this.enablementModal.content["habilitada"] == "S"? "desativar" : "ativar"} a empresa ${this.enablementModal.content["nome_empresa"]}. 
            ${err.response ? err.response.data.message : "Sem resposta do servidor"}`, 
            {
              title: `${this.enablementModal.content["habilitada"] == "S"? "Desativação" : "Ativação"} não realizada.`,
              variant: 'danger',
              solid: true
            }
          );
        });
    },
    formatMoney(s) {
      return (s || '').replace(',','?').replace('.',',').replace('?','.')
    }
  },
};
</script>